
import React from 'react';
import { Img, Loading, BoxArea } from '../component/BaseComponent';
import { HttpsRequest, Session, GetAuth } from '../component/Utils';
import MenuComp, { PageTitle } from "../component/menucomp";

import { Wrapper, Status } from "@googlemaps/react-wrapper";
import MapUI from '../component/GoogleMap';
import GoogleDriverView from './ggl_riders';

import { FaSpinner } from "react-icons/fa";
import { BiMapPin } from "react-icons/bi";
import { BsSpeedometer2 } from "react-icons/bs";
import { ImRoad } from "react-icons/im";
import { HiOutlineStatusOnline } from "react-icons/hi";
import Leaf, { Map as OpenMap } from 'leaflet';
import OpenMapUi, { translate_openmap_gps } from '../component/OpenMap';
import OpenLeafDriveView from "./open_riders"
import { calculate_last_seen_time } from "../component/Utils";
import { Modal } from 'react-bootstrap';



const VANISH_SECONDS = 55000;
const RELOAD_SECONDS = 60000;


const render = (status: Status): React.ReactElement => {
    if (status === Status.FAILURE) return <> Failed to load map </>;
    return (
        <div className='row'> 
            <div className='col-md-12'>
                <Loading />
            </div>
        </div>
    )
};


type MapProp = {
}

type MapState = {

    map_data: mapData[];
    focus_data: Record<string, any>;
    stat_data: Record<string, any>;
    driver_info: Record<string, string | number | boolean>;
    package_data: Record<string, string | number | null>[];
    markers: Record<number, google.maps.Marker>;
    isloaded: boolean;
    data: Record<string, any>;
    drivers: Record<string, number | string | null>;
    rider_data: Record<string, string | number | null>[];
    iconbank: Record<string, string>;
    isbusy: boolean;
    zoom: number;
    key: string;
    center: google.maps.LatLngLiteral;
    map?: google.maps.Map;
    googleins?: google.maps.Map;
    showasset: boolean;
    map_type: number;
    leafmap: OpenMap | null;
    refreshdata: number;
    display_widget: boolean;
    total_distance: Record<string, number>;
    mobile_vehicle: boolean; 
    expiry_msg: string;
    days_left: number|undefined; 
    payment_info?: Record<string, string|number>;
    display_payment_modal: boolean;
}


type mapAreaCallbackType = {
    body: bodyProp | Record<string, any>;
    errormsg?: string;
    status: number;
    httpcode?: number;
    
}

 

class MapAreaUI extends React.Component<MapProp, MapState> {

    constructor(props: MapProp) {
        super(props);

        const mapkey = Session.get("maptoken");
        const lat_center = Session.get("lat_center"),
            lng_center = Session.get("lng_center");

        this.state = {
            map_data: [],
            focus_data: {},
            stat_data: {},
            drivers: {},
            driver_info: {},
            rider_data: [],
            package_data: [],
            iconbank: {},
            markers: {},
            isbusy: false,
            map: undefined,
            googleins: undefined,
            isloaded: false,
            data: [],
            zoom: 12,
            key: mapkey,
            center: {
                lat: Number(lat_center),
                lng: Number(lng_center)
            },
            showasset: true,
            map_type: 0,
            leafmap: null,
            refreshdata: 0,
            display_widget: false,
            total_distance: {},
            mobile_vehicle: false , expiry_msg: "",
            days_left: undefined, payment_info:{}, display_payment_modal: false
        }
    }

    interval: any = null;  // update every 30 seconds 
    package_interval: any = null;

    // TODO: packages are not tracked unless the
    // customer has the logistics mode enabled.   

    toggle_asset_menu = () => {

        this.setState({
            showasset: !this.state.showasset
        })

    }
    close_info = (event: React.SyntheticEvent<HTMLFormElement>) => {
        event.preventDefault();
        let attrs = { ...this.state.driver_info },
            dev = (event.target as HTMLElement).getAttribute('id');

        attrs[dev as string] = false;
        this.setState({ driver_info: attrs })

    }
    close_widget = (event: React.SyntheticEvent<HTMLButtonElement>) => {
        event.preventDefault();
        this.setState({ display_widget: false });
    }

    center_marker = (lat: number, lng: number, data: Record<string, unknown> | null) => {

        if (lat === 0 && data == null) {
            this.setState({
                display_widget: false,
                focus_data: {}
            });

            return
        }

        if (this.state.map !== undefined && this.state.map_type === 1) {
            this.state.map.setCenter({ lat: lat, lng: lng });
        }
        else if (this.state.leafmap && this.state.map_type === 2) {
            this.state.leafmap.panTo([lat, lng])
        }

        // TODO:: write further function to inducate to update the  views here 

        if (data !== null) {

            this.setState({
                display_widget: true,
                focus_data: data
            });
        }

    }

    check_marker_update = (data: mapData) => {

        let new_data: markerProp[] = [], ispresent = false, tmp;

        for (var x = 0; x < this.state.map_data.length; x++) {
            tmp = this.state.map_data[x];

            if (tmp.device_info === data.device_info) {
                new_data.push(data);
                ispresent = true;
            }

            else {
                new_data.push(tmp);
            }
        }

        if (ispresent === false) {
            new_data.push(data)
        }

        this.setState({ map_data: new_data },
            () => { this.center_marker(data.latlng.lat, data.latlng.lng, data) } //confirm the dta structurehre 
        );

    }

    get_callback = (resp: mapAreaCallbackType) => {

        if (resp.status === -1) {
            alert(resp.errormsg)
            return false
        } 
            
        this.setState({
            rider_data: resp.body.rider_data,
            map_data: resp.body.map_data, 
            isbusy: false,
            total_distance: resp.body.distance_covered, 
            expiry_msg: resp.body.expiry_msg,
            days_left: resp.body.days_left,  
            payment_info: resp.body.payment_info  
        });


        if (resp.body.days_left <= 0 ) clearInterval(this.interval)

    }

    initfunc = () => {        
        HttpsRequest.get('/dashboard/locstatus', this.get_callback, GetAuth())
        this.remove_marker();        
    } 

    componentDidMount() {
        
        this.initfunc()
        this.interval = setInterval(this.initfunc, RELOAD_SECONDS);

        this.setState({
            map_type: Number(Session.get('map_type')) || 2
        })

    }

    componentWillUnmount() {

        if (this.interval !== null)
            clearInterval(this.interval);

        // #TODO: until we include logistics tracking
        if (this.package_interval !== null)
            clearInterval(this.package_interval);

    }
    setLeafMap = (map: OpenMap): void => {
        this.setState({
            leafmap: map
        })
    }

    launch_mdl = () => {

        this.setState({
            mobile_vehicle: !this.state.mobile_vehicle
        })
        
    }
     
    render() {

        let _style = { fontSize: "14px", padding: "10px 10px", background: "yellow", color: "red"} 

        if (this.state.days_left! <= 0){
            _style = {background: "pink", color: 'red', fontSize: "14px", padding: "10px 10px"}
        }

        let dynamic_style = {zIndex: 500}
        if (this.state.mobile_vehicle ){
            dynamic_style = Object.assign(dynamic_style, {minHeight: '68vh', overflowY: "auto"})  //@ts-ignore
        }

        return (
            <>
                <MenuComp />
                <br />
                
                <div className='container-fluid'>

                    <div className='row'>
                        {
                            this.state.days_left !== undefined && this.state.days_left <= 30 ? (
                                <div>
                                    <p style={_style}> 
                                        {/** @ts-ignore */}
                                        <marquee>
                                            <span style={{fontSize: "16px"}}> {this.state.expiry_msg} </span> 
                                            <button  onClick={()=>this.setState({'display_payment_modal': true})} className='btn btn-danger btn-sm'> Click To Renew </button>
                                        {/** @ts-ignore */}
                                        </marquee> 
                                    </p>
                                </div>
                            ) : null 
                        }
                        
                        <PageTitle title={'Map'} />                    

                        <BoxArea nopadding classname='col-md-12 col-sm-12 posrel'>
                            <div className='w-100 posrel'>
                                
                                <div className={!this.state.mobile_vehicle?'posabs t-10': "posabs t-10 col-md-5 col-sm-12 px-3"} style={dynamic_style}>
                                    { !this.state.mobile_vehicle? (
                                        <p className='px-2'>
                                            <button onClick={this.launch_mdl} className='btn btn-secondary p-2 px-4'> Show Vehicle(s) </button>
                                        </p>
                                        ) : ( 
                                            <div className="row">
                                            <div className="col-sm-12 col-md-6 border mb-4 p-3" 
                                                style={{borderTopRightRadius: "10px", borderBottomRightRadius: "10px", 
                                                    backgroundColor: "rgb(0 0 0 / 35%)", height: "78vh", width:"100%"}}>
                                                <div>  
                                                    <div className="table-responsive" style={{minHeight: '500px'}}>
                                                        <p className='d-flex justify-content-end'>
                                                            <button className='btn btn-danger' onClick={this.launch_mdl}> X </button>
                                                        </p>                                                                                                                    
                                                        {
                                                            this.state.map_type === 1 && this.state.mobile_vehicle === true? (
                                                                <div className='' style={{borderRadius: '5px'}}>
                                                                <GoogleDriverView
                                                                    drivers={this.state.rider_data}
                                                                    set_other_state={(data:Record<string, any>)=> this.setState({map_data:data.map_data, total_distance: data.total_distance })}
                                                                    show_marker={this.check_marker_update}
                                                                    loc_data={this.state.map_data}
                                                                    center_marker={this.center_marker}
                                                                    map={this.state.map}
                                                                />
                                                                </div>
                                                            ) : this.state.mobile_vehicle === true && this.state.map_type === 2? (
                                                                <div className='' style={{borderRadius: '5px'}}>
                                                                    <OpenLeafDriveView
                                                                        drivers={this.state.rider_data}
                                                                        map={this.state.leafmap!}                                                    
                                                                        show_marker={this.check_marker_update}
                                                                        loc_data={this.state.map_data}
                                                                        center_marker={this.center_marker}
                                                                        set_other_state={(data:Record<string, any>)=> this.setState({map_data:data.map_data, total_distance: data.total_distance })}
                                                                    />                                                                      
                                                                </div>
                                                            ): null 
                                                        } 
                                                    </div>

                                                </div>
                                            </div>
                                            </div> 
                                        )
                                    }
                                </div>
                               
                                <div style={{ height: '80vh', width: "100%"}}>                            
                                                                 
                                    {
                                        this.state.map_type === 1 ? (
                                                                                      
                                            <Wrapper apiKey={this.state.key} render={render}
                                                libraries={["visualization", "geometry", "marker"]}>

                                                <MapUI center={this.state.center} zoom={this.state.zoom} 
                                                    setMap={(map) => this.setState({ map: map })}>
                                                    {
                                                        this.state.map_data.map(
                                                            (itm, idx) => {
                                                                return <DisplayTracker
                                                                    key={`mk-${idx}`}
                                                                    marker_data={itm}
                                                                />
                                                            }
                                                        )
                                                    }
                                                </MapUI>
                                            </Wrapper>
                                               
                                        ) : this.state.map_type === 2 ? (
                                            <OpenMapUi center={translate_openmap_gps(this.state.center)}
                                                zoom={this.state.zoom} setMap={this.setLeafMap}>

                                                {
                                                    this.state.map_data.map(
                                                        (itm, idx) => {
                                                            return <DisplayLeafDevice
                                                                key={`mk-${idx}`}
                                                                marker_data={itm}
                                                                map={this.state.leafmap}
                                                            />
                                                        }
                                                    )
                                                }
                                            </OpenMapUi>

                                        ) : <></>
                                    }
                                  

                                </div>

                                {
                                    this.state.display_widget ? (
                                        <>
                                            <div className='absolute top zindex' style={{ top: '15px', left: '15px' }} >

                                                {/* <span className='badge bg-primary p-2' style={{ fontSize: '17px' }}>
                                                    &nbsp;  <FaRegUserCircle size={20} /> &nbsp; {this.state.focus_data.rider_name}  &nbsp;
                                                </span> */}

                                            </div>
                                            <div className='absolute top zindex' style={{ right: '15px', top: '15px' }}>
                                                <button onClick={this.close_widget} title='click to close widgets'
                                                    type='button' className='btn btn-danger'> X </button>
                                            </div>


                                            <div className={'absolute bottom zindex'}
                                                style={{ width: "inherit", bottom: '2%', padding: '20px' }}>
                                                <div style={{ backgroundColor: "#fff", borderRadius: '10px', border: "solid 2px #ccc" }}>
                                                    <div className='row p-1'>
                                                        <div className='col-md-3 col-xs-12'>
                                                            <p className='text-center pt-3'>
                                                                <BiMapPin /> <span> Current Location </span>  <br />
                                                                <span className='text-muted'> {this.state.focus_data.address_lookup} </span>
                                                            </p>
                                                        </div>
                                                        <div className="col-md-3 col-xs-12">
                                                            <p className='text-center pt-3'>
                                                                <BsSpeedometer2 /> &nbsp; <span> Speed </span> <br />
                                                                <span className='text-muted'> {this.state.focus_data.speed} </span>
                                                            </p>
                                                        </div>
                                                        <div className="col-md-3 col-xs-12">
                                                            <p className='text-center pt-3'>
                                                                <ImRoad /> &nbsp; <span> Distance Covered </span> <br />
                                                                <span className='text-muted'> {this.state.total_distance[this.state.focus_data.device_info] || 0} Km </span>

                                                            </p>
                                                        </div>
                                                        <div className="col-md-3 col-xs-12">
                                                            <p className='text-center pt-3'>
                                                                <HiOutlineStatusOnline /> &nbsp; <span> Status  </span> <br />
                                                                <span className='text-muted'> {calculate_last_seen_time(this.state.focus_data.last_update || null)} </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </>

                                    ) : null
                                }

                            </div>
                            <br />
                            
                            <div className='row'>
                               
                                <div className='col-sm-12 col-md-6 mb-4' style={{padding: '5px 20px'}}>
                                    <h5> Map Legend </h5>
                                    <br />
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <Img id={'nosig'}
                                                title={'no signal from tracker'}
                                                src={'/static/nosig.png'}
                                                className={'lagend_img'}
                                            />
                                            &nbsp; No Movement detected
                                        </div>
                                        <div className='col-md-4'>
                                            <Img id={'parkedsign'}
                                                title={'parked or stop sign'}
                                                src={'/static/parksign.png'}
                                                className={'lagend_img'}
                                            />
                                            &nbsp; engine off
                                        </div>
                                        <div className='col-md-4'>
                                            <Img id={'parkedsign'}
                                                title={'parked or stop sign'}
                                                src={'/static/ed2.png'}
                                                className={'lagend_img'}
                                            />
                                            &nbsp; movement detected
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </BoxArea>

                        <Modal show={this.state.days_left != undefined && this.state.days_left <= 0 || this.state.display_payment_modal} size={'lg'} centered>
                            <Modal.Body>
                                <div>
                                    <h2>  Account Renewal Summary </h2> 
                                    <hr/> 

                                    <table className='table table-condensed table-striped'>
                                        
                                        <tbody>

                                            <tr>
                                                <td> Total Devices </td> <th> {this.state.payment_info?.['total_trackers']} </th>
                                            </tr>
                                            <tr> 
                                                <td> Date Expired </td> <th> {this.state.payment_info?.['expiry_date']}  </th> 
                                            </tr>
                                            <tr> 
                                                <td> Amount </td> <th> NGN {this.state.payment_info?.["total_subscription"]} </th>                                                 
                                            </tr>                                            
                                        </tbody>
                                    </table>
                                    <br />
                                    <p className='d-grid gap-3'>
                                        <button className='btn btn-warning' onClick={ this.state.isbusy? undefined: this.generate_payment_link }> 
                                          
                                            {
                                                this.state.isbusy? (
                                                    <span>  <FaSpinner size={20} className='spin'/> {" "}  Loading please wait ... </span>
                                                ) : <span>   Please Renew Now   </span> 
                                            }
                                            
                                        </button>
                                        <a href="/#/logout" className='btn btn-default'> <b> Exit </b> </a>
                                    </p>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div >
                </div>

                <br />
            </>
        )
    }


    generate_payment_link = (e:any) => {
        e.preventDefault()
        const on_success_callback = (resp: mapAreaCallbackType) => {            
            console.log(resp);
            
            this.setState({
                isbusy: false
            })
            
            if (resp.status == 0){                
                let ret = window.confirm("You will be redirected to paystack to complete the payment. Please confirm")
                if (!ret) return 

                //@ts-ignore
                window.location = resp.body?.authorization_url

            } else if (resp.status == -1 ) {
                alert(resp.errormsg);
            }
            
        }

        HttpsRequest.get("/activation/payinit", on_success_callback, GetAuth(), {payment_type:"renewal"})
        this.setState({isbusy: true})
        
    }
    map_markers: markerStoreProp[] = []

    remove_marker = () => {

        for (var x = 0; x < this.map_markers.length; x++) {
            this.map_markers[x].marker.setMap(null);
        }
    }
}


function DisplayTracker({ marker_data, map }: LoadMarkerProp) {
 
    // if (map === undefined) return null
    
    const img = document.createElement('img')
    img.src = marker_data.image;

    const new_marker = new google.maps.Marker({
        position: marker_data.latlng,
        map: map,
        title: marker_data.rider,
        icon: marker_data.image // marker_data.image 
    });
    const infowindow = new google.maps.InfoWindow({
        content: marker_data.title,
        ariaLabel: marker_data.rider
    });

 
    new_marker.addListener("click", () => {
        infowindow.open({
            anchor: new_marker,
            map
        })
    });

    setTimeout(() =>(new_marker.setMap(null)), VANISH_SECONDS);

    return null

}


function DisplayLeafDevice({ marker_data, map }: LoadLeafMarkerProp) {

    if (!map || marker_data.latlng.lat === 0) {
        return null
    }

    const { latlng } = marker_data;
 
    const new_marker = new Leaf.Marker(
        [latlng.lat, latlng.lng],
        {
            title: marker_data.rider,
            icon: new Leaf.Icon(
                {
                    iconUrl: marker_data.image,
                    iconSize: [50, 50]
                }
            )
        }
    )

    new_marker.addTo(map)
        .bindPopup(marker_data.title);

    setTimeout(
        () => (new_marker.remove()), VANISH_SECONDS
    );

    return null;

}

function LoadPackages({ data, lng, showinfo, iconbank }: LoadPackageProp) {
    // deprecated package method
    let title = data.area + `${lng}`;

    let styles = {
        bottom: '45px', left: 0,
        backgroundColor: '#ffffff',
        width: '130px', padding: '10px 10px',
        borderRadius: '10px', border: 'solid 1px #ccc',
        position: 'absolute',
        display: iconbank[title] ? 'block' : 'none'
    }

    return (<div className='' style={{ position: 'relative' }}>
        <Img id={title}
            title={data.type}
            style={{ cursor: 'pointer' }}
            clickfunc={showinfo}
            src={data.image_path}
            attr={JSON.stringify(data)}
            alt=""
        />
        <div style={styles as React.CSSProperties}
            dangerouslySetInnerHTML={{ __html: data.label as string }} />
    </div>
    )
}


export default MapAreaUI;

